module.exports = __webpack_public_path__ + "img/onboarding_background.42063e2.jpeg";